import row from './row.component.js';
import rowService from './row.service';

angular.module('rym.rows', []).component('rymRow', row).service('rowService', rowService);
